import { EventMeta } from '../../../interfaces/meta.interface';

const updateComplianceTag: EventMeta = {
    title: 'Update Compliance Tag',
    default: {
        description: 'Update Compliance Tag',
        longDescription:
            'A different retention label was applied to a mail item (an item can only have one retention label assigned to it).',
        severity: 'info',
    },
};

export default updateComplianceTag;
